import { memo, useMemo, useId } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseRounded from '@mui/icons-material/CloseRounded';
import _map from 'lodash/map';
import { optionValue, optionLabel, filterOptionsList, labelForSelectedFilterValue } from 'helpers/filterHelpers';

const BaseFilter = ({ data, value, onChange, label }) => {
  const dataList = useMemo(() => filterOptionsList(data), [data]);
  const reactId = useId();
  const idPrefix = useMemo(() => `base-filter-${reactId.replace(/:/g, '')}`, [reactId]);
  const labelId = `${idPrefix}-label`;
  const selectId = `${idPrefix}-select`;

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        id={selectId}
        multiple
        label={label}
        value={value}
        onChange={({ target: { value: v } }) => onChange(v)}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {_map(selected, (s) => (
              <Chip
                key={String(s)}
                sx={{ textTransform: 'capitalize' }}
                label={labelForSelectedFilterValue(data, s)}
              />
            ))}
          </Box>
        )}
        endAdornment={
          <IconButton sx={{ right: 10 }} onClick={() => onChange([])}>
            <CloseRounded fontSize="small" />
          </IconButton>
        }
      >
        {_map(dataList, (item, idx) => (
          <MenuItem
            key={`${String(optionValue(item))}-${idx}`}
            value={optionValue(item)}
            sx={{ textTransform: 'capitalize' }}
          >
            {optionLabel(item)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(BaseFilter);
